import { Grid } from "@material-ui/core";
import React from "react";
import { handleKeyDown } from "../../common/common";
import { expenseResultField } from "../../constants";
import CustomShowModal from "../Common/CustomShowModal";
import ExpenseBreakdownModal from "./ExpenseBreakdownModal";
import { fmt3 } from "../../utils";

function Expenses(props) {
  const [localFreight, setLocalFreight] = React.useState("");
  const [localGbb, setLocalGbb] = React.useState("");
  const [localHirePerDay, setLocalHirePerDay] = React.useState("");
  const [localHireGbb, setLocalHireGbb] = React.useState("");
  const [focusedField, setFocusedField] = React.useState(null);
  const [expenseModalField, setExpenseModalField] = React.useState(null);
  const {
    selectedVessels = {},
    onChangeSelectedVessel = () => { },
    openSplitHireModal = () => { },
    calculatorData = {},
    setCalculatorData = () => { },
    onChangeChartValue = () => { },
    isFromSingleVesselCalcy = false,
    setShowExpensesModal = () => { },
  } = props || {};

  const { clientQuery = {}, portOperation = [] } = calculatorData || {};

  const onChangeQueryValues = (e) => {
    const { name = "", value = "" } = e.target;

    let newPortOperation = [...portOperation];
    let newCargoList = [...(clientQuery.cargoList || [])];

    if (name === "freightIdea") {
      newPortOperation = newPortOperation.map((item) => {
        if (item.operation === "Loading") {
          return { ...item, freight: Number(value) };
        }
        return item;
      });
      newCargoList = newCargoList.map((item) => {
        if (item.operation === "Loading") {
          return { ...item, freight: Number(value) };
        }
        return item;
      });
    }

    const updated = {
      ...calculatorData,
      clientQuery: {
        ...clientQuery,
        cargoList: newCargoList,
        [name]: Number(value),
      },
      portOperation: newPortOperation,
    };

    setCalculatorData(updated);
    onChangeChartValue(updated);
  };

  const {
    hireGbb = 0,
    hirePerDay = 0,
    profitPerDay = 0,
    profitPerDayGBB = 0,
    tcEq = 0,
    gbb = 0,
  } = selectedVessels || {};

  const {
    freightMode = "",
    miscRevenue = 0,
    cargoList
  } = clientQuery || {};
  const freight = cargoList?.filter((item) => item.operation === 'Loading')
  let freightIdea = 0
  const disablefreightIdea = freightMode === "Multiple Freight";
  freightIdea = disablefreightIdea ? freight?.reduce((sum, item) => Number(item.freight || 0) + sum, 0) : freight?.[0]?.freight || 0

  const safeVal = (val, decimals = 2) => {
    const num = Number(val);
    return isNaN(num) ? "0" : fmt3(num);
  };

  // Sync local state from props when the field is NOT focused
  React.useEffect(() => {
    if (focusedField !== "freightIdea")
      setLocalFreight(safeVal(freightIdea));
  }, [freightIdea, focusedField]);

  React.useEffect(() => {
    if (focusedField !== "gbb")
      setLocalGbb(safeVal(gbb));
  }, [gbb, focusedField]);

  React.useEffect(() => {
    if (focusedField !== "hirePerDay")
      setLocalHirePerDay(safeVal(hirePerDay));
  }, [hirePerDay, focusedField]);

  React.useEffect(() => {
    if (focusedField !== "hireGbb")
      setLocalHireGbb(safeVal(hireGbb));
  }, [hireGbb, focusedField]);

  // On blur: parse, reformat display, commit to parent
  const makeBlurHandler = (fieldName, setter, commitFn) => (e) => {
    const raw = parseFloat(e.target.value);
    const numVal = isNaN(raw) ? 0 : raw;
    setter(fmt3(numVal));
    setFocusedField(null);
    commitFn({ target: { name: fieldName, value: String(numVal) } });
  };

  return (
    <Grid container>

      {/* HEADER */}
      <Grid item xs={12} className="calculator-section-header freight-result-header">
        <div className="flex items-center justify-between w-full">
          <h4 className="result-heading font-medium text-[12px] m-0" style={{ color: "#ffffff" }}>Freight and Result</h4>
          <span className="font-medium text-[10px] m-0" style={{ color: "#ffffff" }}>GBB</span>
        </div>
      </Grid>

      {/* FREIGHT & RESULT TABLE */}
      <Grid item xs={12}>
        <div>
          <table className="fleet-result-table low-th-width compact-table w-full">

            <tr>
              <th>Freight Rate</th>
              <td>
                <input
                  className="text-[11px]"
                  type="number"
                  onKeyDown={handleKeyDown}
                  value={localFreight}
                  name="freightIdea"
                  onFocus={() => setFocusedField("freightIdea")}
                  onChange={(e) => setLocalFreight(e.target.value)}
                  onBlur={makeBlurHandler("freightIdea", setLocalFreight, onChangeQueryValues)}
                  disabled={disablefreightIdea}
                />
              </td>
              <td></td>
            </tr>

            <tr>
              <th>TC Eq</th>
              <td style={{ backgroundColor: "#ffffff" }}>
                <p className="text-[11px] font-medium m-0 px-1.5 flex items-center h-[15px] bg-white text-slate-900">{safeVal(tcEq)}</p>
              </td>
              <td>
                <input
                  className="text-[11px]"
                  type="number"
                  onKeyDown={handleKeyDown}
                  placeholder="0"
                  value={localGbb}
                  name="gbb"
                  onFocus={() => setFocusedField("gbb")}
                  onChange={(e) => setLocalGbb(e.target.value)}
                  onBlur={makeBlurHandler("gbb", setLocalGbb, (e) => onChangeSelectedVessel(e, true))}
                />
              </td>
            </tr>

            <tr>
              <th
                className="cursor-pointer underline"
                style={{ color: "#000000" }}
                onClick={() => openSplitHireModal(selectedVessels)}
              >
                Hire Per Day
              </th>
              <td>
                <input
                  className="text-[11px]"
                  type="number"
                  onKeyDown={handleKeyDown}
                  placeholder="0"
                  value={localHirePerDay}
                  name="hirePerDay"
                  onFocus={() => setFocusedField("hirePerDay")}
                  onChange={(e) => setLocalHirePerDay(e.target.value)}
                  onBlur={makeBlurHandler("hirePerDay", setLocalHirePerDay, (e) => onChangeSelectedVessel(e, true))}
                />
              </td>
              <td>
                <input
                  className="text-[11px]"
                  type="number"
                  onKeyDown={handleKeyDown}
                  placeholder="0"
                  value={localHireGbb}
                  name="hireGbb"
                  onFocus={() => setFocusedField("hireGbb")}
                  onChange={(e) => setLocalHireGbb(e.target.value)}
                  onBlur={makeBlurHandler("hireGbb", setLocalHireGbb, (e) => onChangeSelectedVessel(e, true))}
                />
              </td>
            </tr>

            <tr>
              <th>Profit/day</th>
              <td style={{ backgroundColor: "#ffffff" }}>
                <p
                  className="text-[11px] font-medium m-0 px-1.5 h-[15px] bg-white text-slate-900 block w-full min-w-0 overflow-hidden text-ellipsis whitespace-nowrap"
                  title={safeVal(profitPerDay)}
                >
                  {safeVal(profitPerDay)}
                </p>
              </td>
              <td style={{ backgroundColor: "#ffffff" }}>
                <p
                  className="text-[11px] font-medium m-0 px-1.5 h-[15px] bg-white text-slate-900 block w-full min-w-0 overflow-hidden text-ellipsis whitespace-nowrap"
                  title={safeVal(profitPerDayGBB)}
                >
                  {safeVal(profitPerDayGBB)}
                </p>
              </td>
            </tr>
          </table>

          {/* REVENUE */}
          <div className="text-[11px] font-semibold text-slate-800 px-2 py-0.5 mt-0.5 bg-slate-200 border-y border-slate-300">Revenue</div>
          <table className="fleet-result-table compact-table w-full has-border-top">
            <tr className="border-t border-[#cbd5e1]">
              <th style={{ borderTop: "1px solid #cbd5e1" }}>Misc Revenue</th>
              <td style={{ borderTop: "1px solid #cbd5e1" }}>
                <input
                  type="number"
                  onKeyDown={handleKeyDown}
                  placeholder="0"
                  onChange={onChangeQueryValues}
                  value={miscRevenue || ""}
                  name="miscRevenue"
                />
              </td>
            </tr>
          </table>

          {/* EXPENSES */}
          <div className="text-[11px] font-semibold text-slate-800 px-2 py-0.5 mt-0.5 bg-slate-200 border-y border-slate-300">Expenses</div>
          <table className="fleet-result-table compact-table w-full has-border-top">
            {expenseResultField.map((item, key) => {
              const isDailyExpenses = item.value === "expensesPerDay";
              const hasItemsKey = Boolean(item.itemsKey);

              const dailyExpensesSum = isDailyExpenses
                ? (calculatorData?.clientQuery?.dailyExpenses || []).reduce(
                  (sum, entry) =>
                    entry.value && entry.label ? sum + Number(entry.value) : sum,
                  0
                )
                : 0;

              // For expense keys with breakdown: compute sum from items array
              let breakdownSum = 0;
              if (hasItemsKey) {
                const items = calculatorData?.clientQuery?.[item.itemsKey];
                if (items && Array.isArray(items)) {
                  breakdownSum = items.reduce(
                    (sum, entry) => sum + (Number(entry.value) || 0),
                    0
                  );
                } else {
                  // Auto-migrate: if there's a plain number value but no items array,
                  // use the existing value as the sum
                  breakdownSum = Number(clientQuery[item.value]) || 0;
                }
              }

              const openExpenseModal = () => {
                if (isDailyExpenses) return setShowExpensesModal(true);
                // Auto-migrate on first click if no items array exists
                const existing = calculatorData?.clientQuery?.[item.itemsKey];
                if (!existing || !Array.isArray(existing)) {
                  const currentVal = Number(clientQuery[item.value]) || 0;
                  setCalculatorData((prev) => ({
                    ...prev,
                    clientQuery: {
                      ...prev.clientQuery,
                      [item.itemsKey]: [{ label: item.label, value: currentVal }],
                    },
                  }));
                }
                setExpenseModalField(item);
              };

              return (
                <tr key={key} className={key === 0 ? "border-t border-[#cbd5e1]" : ""}>
                  <th style={key === 0 ? { borderTop: "1px solid #cbd5e1" } : {}}>
                    {isDailyExpenses ? (
                      <span
                        style={{
                          color: "#000000",
                          cursor: "pointer",
                          textDecoration: "underline",
                          fontWeight: 500,
                        }}
                        onClick={openExpenseModal}
                      >
                        {item.label}
                      </span>
                    ) : hasItemsKey ? (
                      <span
                        style={{
                          color: "#000000",
                          cursor: "pointer",
                          textDecoration: "underline",
                          fontWeight: 500,
                        }}
                        onClick={openExpenseModal}
                      >
                        {item.label}
                      </span>
                    ) : (
                      item.label
                    )}
                  </th>

                  <td
                    style={{
                      ...(key === 0 ? { borderTop: "1px solid #cbd5e1" } : {}),
                      ...(isDailyExpenses || hasItemsKey ? { cursor: "pointer", userSelect: "none" } : {}),
                    }}
                    onClick={isDailyExpenses || hasItemsKey ? openExpenseModal : undefined}
                  >
                    {isDailyExpenses ? (
                      <span style={{ fontWeight: 500 }}>{dailyExpensesSum}</span>
                    ) : hasItemsKey ? (
                      <span style={{ fontWeight: 500 }}>{breakdownSum}</span>
                    ) : (
                      <input
                        type="number"
                        onKeyDown={handleKeyDown}
                        placeholder="0"
                        onChange={onChangeQueryValues}
                        value={clientQuery[item.value] || ""}
                        name={item.value}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
      </Grid>

      {/* SINGLE VESSEL SECTION */}
      {isFromSingleVesselCalcy ? (
        <Grid item xs={12}>
          <p className="m-t-10 m-l-5 m-b-5" style={{ fontSize: 13, fontWeight: 600 }}>
            This Vessel:
          </p>

          <table className="fleet-result-table compact-table">
            <tr>
              <th>Extra Expenses</th>
              <td>
                <input
                  type="number"
                  onKeyDown={handleKeyDown}
                  placeholder="0"
                  onChange={(e) => onChangeSelectedVessel(e, true)}
                  value={selectedVessels?.extraExpense || 0}
                  name="extraExpense"
                />
              </td>
            </tr>

            <tr>
              <th>Constants</th>
              <td>
                <input
                  type="number"
                  onKeyDown={handleKeyDown}
                  placeholder="0"
                  onChange={(e) => onChangeSelectedVessel(e, true)}
                  value={selectedVessels?.constants || 0}
                  name="constants"
                />
              </td>
            </tr>
          </table>
        </Grid>
      ) : null}
      {/* Expense Breakdown Modal */}
      {expenseModalField && (
        <CustomShowModal
          open={Boolean(expenseModalField)}
          handleClose={() => setExpenseModalField(null)}
          maxWidth="xs"
          title={expenseModalField.label}
        >
          <ExpenseBreakdownModal
            expenseLabel={expenseModalField.label}
            items={
              calculatorData?.clientQuery?.[expenseModalField.itemsKey] ||
              [{ label: expenseModalField.label, value: Number(clientQuery[expenseModalField.value]) || 0 }]
            }
            onChange={(updatedItems, sum) => {
              setCalculatorData((prev) => ({
                ...prev,
                clientQuery: {
                  ...prev.clientQuery,
                  [expenseModalField.itemsKey]: updatedItems,
                  [expenseModalField.value]: sum,
                },
              }));
            }}
          />
        </CustomShowModal>
      )}
    </Grid>
  );
}

export default Expenses;
